import script from "./UnexpectedEventAndAlertStatuseList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnexpectedEventAndAlertStatuseList.vue?vue&type=script&setup=true&lang=ts"

import "./UnexpectedEventAndAlertStatuseList.vue?vue&type=style&index=0&id=a77199c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a77199c8"]])

export default __exports__